export const COLOR_PRIMARY = '#dc1d30';

export const COLOR_BLUE = '#013c89';
export const COLOR_RED = '#dc1d30';

export const COLOR_GREY_LIGHT_1 = '#f6f6f6';
export const COLOR_GREY_LIGHT_2 = '#dddddd';

export const COLOR_GREY_TEXT_1 = '#222222';
export const COLOR_GREY_TEXT_2 = '#444444';
export const COLOR_GREY_TEXT_3 = '#666666';
export const COLOR_GREY_TEXT_4 = '#888888';

export const FONT_SIZE_DEFAULT = '0.8rem';
export const FONT_SIZE_S = '0.7rem';

export const HEADER_HEIGHT_PX = 60;
